module.exports = __webpack_public_path__ + "static/media/logo_parque_tecnologico_sjc.4ff93d51.png";